var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"logo"},[_c('LogoComponent')],1),_c('a',{staticClass:"about",attrs:{"href":"/"}},[_vm._v("关于我们")])]),_c('Banner4')],1)}
var staticRenderFns = []

export { render, staticRenderFns }